"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TranslationSourceStore = /*#__PURE__*/function (_RootStore) {
  function TranslationSourceStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, TranslationSourceStore);
    _this = _callSuper(this, TranslationSourceStore);
    _this.config = {
      model: _models.TranslationSource,
      deserialize: true,
      GET: {
        index: '/translation_sources',
        show: '/translation_sources/:translationSourceId'
      },
      PUT: {
        update: '/translation_sources/:translationSourceId'
      },
      POST: {
        create: '/translation_sources',
        destroyWithoutId: '/translation_sources/destroy_without_id'
      },
      DELETE: {
        destroy: '/translation_sources/:translationSourceId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(TranslationSourceStore, _RootStore);
  return (0, _createClass2["default"])(TranslationSourceStore, [{
    key: "destroyWithoutId",
    value: function destroyWithoutId(params, callback) {
      this.api(params, callback, 'POST', 'destroyWithoutId');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new TranslationSourceStore();